<template>
  <v-list-tile>
    <v-list-tile-action style="min-width: 30px; margin-right: 10px">
      <v-img
        :height="45"
        :width="70"
        :src="`/img/Dark Color/${paymentMethod.brand}.png`"
        cover
      />
    </v-list-tile-action>

    <v-list-tile-content>
      <v-list-tile-title>
        **** {{ paymentMethod.last4 }}
      </v-list-tile-title>

      <v-list-tile-sub-title>
        {{ $vuetify.t('$vuetify.common.expires') }}: {{ paymentMethod.expired}}
      </v-list-tile-sub-title>
    </v-list-tile-content>

    <card-error-chip :card="paymentMethod" />

    <v-list-tile-action>
      <v-icon color="error" @click="confirmDelete = true">
        delete_outline
      </v-icon>
    </v-list-tile-action>

    <v-dialog v-model="confirmDelete" max-width="300px">
      <v-card>
        <v-card-title class="white--text error title">
          {{ $vuetify.t('$vuetify.account.payment.title') }}
        </v-card-title>

        <v-card-text style="text-align: left">
          {{ $vuetify.t('$vuetify.account.payment.body') }}
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn outline @click="confirmDelete = false" :disabled="isLoading">
            {{ $vuetify.t('$vuetify.account.payment.cancel') }}
          </v-btn>

          <v-btn
            color="error"
            :loading="isLoading"
            :disabled="isLoading"
            @click="onDeletePaymentMethod(paymentMethod.paymentMethodId)"
          >
            {{ $vuetify.t('$vuetify.account.payment.delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-tile>
</template>

<script>
  import { mapActions } from 'vuex'

  import CardErrorChip from '@/components/Account/CardErrorChip.vue'

  export default {
    components: { CardErrorChip },
    props: {
      paymentMethod: {
        type: Object,
        default: () => { }
      }
    },

    data() {
      return {
        confirmDelete: false,
        isLoading: false
      }
    },

    methods: {
      onDeletePaymentMethod(id) {
        if (this.isLoading)
          return

        this.isLoading = true

        this.deletePaymentMethod(id).finally(res => {
          this.isLoading = false
          this.confirmDelete = false
        })
      },

      ...mapActions([ 'deletePaymentMethod' ])
    }
  }
</script>

<style>
  #PaymentMethodItem div[role=listitem]:hover {
    background-color: var(--hover-colour) !important;
  }
</style>